<template lang='pug'>
  form.sign-up-form( @submit.prevent='link' )
    fieldset
      bf-input
        template(slot='icon')
          img(src='/ui/email-icon.png')
        input( required type='email' :placeholder='$t( "Email" )' v-model='email' )

      bf-input
        template(slot='icon')
          img(src='/ui/password-icon.png')
        input( required :type='type' :placeholder='$t( "Password" )' v-model='password' )

        template(slot='reveal')
          img(v-if="type=='password'" src='/ui/eyeopen.svg' width="30" @click='reveal' )
          img(v-else src='/ui/eyeclose.svg' width="30" @click='reveal' )
    
    bf-flex.button-links.centered
      bf-button.large.combo.solid.submit( type='submit' )
        template( slot='text' ) {{ $t('Link Now') }}
</template>

<script>
  import { auth, firebase } from '@/main'
  import AuthLayout from '@/layouts/auth'
  import AuthBody from '@/components/auth-body'
  import TermsPolicy from '@/components/terms-policy'

  import { Animatable } from '@/mixins/view'

  export default {
    name: 'view.sign-in',

    mixins: [ Animatable ],

    components: {
      AuthLayout,
      AuthBody,
      TermsPolicy
    },

    props: {
      user: { type: Object, required: true }
    },


    data() {
      return {
        email: '',
        password: '',
        type: 'password'
      }
    },

    methods: {
      link() {
        let credential = firebase.auth.EmailAuthProvider.credential( this.email, this.password )
        this.user.linkWithCredential( credential ).then( cred => 
          this.$emit( 'password-linked', cred.user )
        ).catch( e => alert( e.message ) )
      },

      reveal() {
        if( this.type == 'password') {
          this.type = 'text'
        } else {
          this.type = 'password'
        }
      }
    }
  }
</script>

<style scoped lang='stylus'>
  .v-leave-to
    transform scale( .88 ) translateY( 440px )
    transition all 480ms
    height 0
    *
      display none

  .button-links
    margin-top 26px
    align-items center
    justify-content space-between
    .forgot-password-link
      margin-left 8px
      text-align right

  .remember-me
    margin 16px
    align-items center
    input
      margin-right 8px
</style>